export default __webpack_public_path__ + "static/media/ic_france.80e5ffae.svg";